<div class="call-log-details-sms-info">
  <p class="vox-paragraph">
    <span [innerHTML]="'events.company-call-history.details.sms.text' | Translate"></span>
  </p>
</div>
<div>
  <div
    class="call-log-details-sms"
    *ngFor="let s of smsItems">
    <div class="vox-card call-log-details-sms-card">
      <div class="description">
        <div>
          <div class="description-sender">
            <b class="vox-text-black">{{ "events.company-call-history.details.sms.sender" | Translate }}:&nbsp;</b>
            <p class="sender-name">{{ s.sender }}</p>
          </div>
          <div
            class="description-recipient"
            *ngIf="s?.recipient">
            <b class="vox-text-black">{{ "events.company-call-history.details.sms.recipient" | Translate }}:&nbsp;</b
            ><a
              href="tel:{{ s.recipient }}"
              target="_blank"
              >{{ s.recipient }}</a
            >
          </div>
        </div>
        <div
          class="description-recipient"
          *ngIf="s?.timestamp">
          <b class="vox-text-black"> {{ "events.company-call-history.details.sms.date" | Translate }}:&nbsp;</b>
          <p class="sender-name">{{ s.timestamp | date: dateFormat : undefined : locale }}</p>
        </div>
      </div>
      <p class="vox-paragraph sender-message">
        <span>{{ s.message }}</span>
      </p>
      <app-clipboard-box [text]="s.message"
        ><span class="vox-btn copy-btn icon-small-copy-outline"></span
      ></app-clipboard-box>
    </div>
  </div>
</div>
